import OnboardingCoachmark from '../OnboardingCoachmark';
import { InstallApplicationOnboardingCoachmarkProps } from './types';
import { usePwaInstallation } from '../../model/pwaInstallation';
import { useRef, useState } from 'react';

const InstallApplicationOnboardingCoachmark = (props: InstallApplicationOnboardingCoachmarkProps) => {
  const {
    isOpen,
    onClose,
    onComplete,
    onOpenInstructions,
    scenario,
    stepNumber,
    totalSteps
  } = props;
  const isPromptPendingRef = useRef(false);
  const [isPromptPending, setIsPromptPending] = useState(false);
  const { promptNativeInstallation } = usePwaInstallation();
  const isNativeScenario = scenario === 'NATIVE';

  const onPrimaryAction = async (): Promise<void> => {
    if (!isNativeScenario) {
      onOpenInstructions();
      return;
    }

    if (isPromptPendingRef.current) return;

    isPromptPendingRef.current = true;
    setIsPromptPending(true);

    try {
      const outcome = await promptNativeInstallation();

      if (outcome === 'accepted' || outcome === 'dismissed') {
        onComplete();
        return;
      }

      onClose();
    } catch {
      onClose();
    } finally {
      isPromptPendingRef.current = false;
      setIsPromptPending(false);
    }
  };

  return (
    <OnboardingCoachmark
      description="Быстрый доступ к поставкам и документам."
      isOpen={isOpen}
      isPrimaryActionDisabled={isPromptPending}
      onClose={onClose}
      onPrimaryAction={onPrimaryAction}
      onSecondaryAction={onComplete}
      placement="center"
      primaryActionLabel={isNativeScenario ? 'Установить' : 'Как установить'}
      secondaryActionLabel="Не сейчас"
      shouldShowBack={false}
      stepNumber={stepNumber}
      title="Установите приложение"
      totalSteps={totalSteps}
      width={290}
    />
  );
};

export default InstallApplicationOnboardingCoachmark;